import type { $Fetch } from 'ofetch';
import type { ContratoAssinaturaGateway } from '@/application/port/out/ContratoAssinaturaGateway';
import type { ContratoExtended, GerarContratoAssinaturaCommand } from '@/domain/model/Contrato';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/**
 * HTTP gateway da assinatura de contrato (acadadmin). Root `/api/v1/contratos`.
 * Authorities `acadadmin:contrato:read|gerar|assinar|revogar`.
 *
 * @since G.5.24
 */
const PATH = '/api/v1/contratos';

export class HttpContratoAssinaturaGateway implements ContratoAssinaturaGateway {
  constructor(private readonly client: $Fetch) {}

  async get(id: string): Promise<ContratoExtended> {
    const res = await this.client<ApiResponse<ContratoExtended>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }
  async gerar(cmd: GerarContratoAssinaturaCommand): Promise<ContratoExtended> {
    const res = await this.client<ApiResponse<ContratoExtended>>(`${PATH}/gerar`, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }
  async recusar(id: string, motivo: string): Promise<ContratoExtended> {
    const res = await this.client<ApiResponse<ContratoExtended>>(
      `${PATH}/${encodeURIComponent(id)}/recusar`, { method: 'POST', body: { motivo } });
    assertApiSuccess(res);
    return res.data;
  }
  async revogar(id: string, motivo: string): Promise<ContratoExtended> {
    const res = await this.client<ApiResponse<ContratoExtended>>(
      `${PATH}/${encodeURIComponent(id)}/revogar`, { method: 'POST', body: { motivo } });
    assertApiSuccess(res);
    return res.data;
  }
}
